module.exports = __webpack_public_path__ + "img/BCN.c1bb7518.png";